import { useT } from '../context/LanguageContext';
import React, { useState } from 'react';
import { useContent } from '../context/ContentContext';
import { EditButton } from './admin/EditorShell';
import { SchemaEditor } from './admin/SchemaEditor';

import { ListMusic } from 'lucide-react';

const SPOTIFY_EMBED = 'https://open.spotify.com/embed/playlist/3sjtslfttSXF1ZrA7DdQYA?utm_source=generator&si=eb14aa22ca424f15';

const SPOTIFY_SCHEMA = [{ key: 'embed', label: 'Spotify-innbygging', type: 'textarea', rows: 5, placeholder: '<iframe src="https://open.spotify.com/embed/..."></iframe> eller berre lenka', help: 'Lim inn heile <iframe>-koden frå Spotify (Del → Bygg inn) eller berre adressa. Berre open.spotify.com blir godteke.' }];
const spotifySrc = (embed) => { const m = (embed || '').match(/src=["']([^"']+)["']/); const u = (m ? m[1] : (embed || '').trim()); return /^https:\/\/open\.spotify\.com\//.test(u) ? u : null; };

const Worship = () => {
  const { content } = useContent();
  const [editing, setEditing] = useState(false);
  const src = spotifySrc(content.spotify?.embed) || SPOTIFY_EMBED;
  const { t } = useT();
  return (
    <section id="lovsang" className="bg-black py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1DB954]/10 text-[#1DB954] font-semibold uppercase text-xs tracking-widest mb-4">
            <ListMusic size={16} /> {t('Spotify-speleliste')}
          </div>
          <h2
            className="text-4xl md:text-6xl font-bold text-white tracking-tighter"
            style={{ fontFamily: "'Oktah Round', sans-serif" }}
          >
            {t('Sjå kva lovsongar som spelast')}
          </h2>
        </div>

        <div className="flex justify-end mb-3"><EditButton onClick={() => setEditing(true)} label="Rediger Spotify" testId="edit-spotify-button" /></div>
        <div className="rounded-3xl bg-[#1a1424] border border-white/5 p-3 md:p-4 shadow-2xl shadow-black/50" data-testid="spotify-embed-container">
          <iframe
            data-testid="spotify-iframe"
            title="Refuel Weekend – lovsongar på Spotify"
            style={{ borderRadius: 12, border: 0 }}
            src={src}
            width="100%"
            height="352"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
      {editing && <SchemaEditor contentKey="spotify" title="Rediger Spotify-spelaren" initial={content.spotify || { embed: SPOTIFY_EMBED }} schema={SPOTIFY_SCHEMA} single onClose={() => setEditing(false)} />}
    </section>
  );
};

export default Worship;
